import { render, staticRenderFns } from "./LivingOptionSubsections.vue?vue&type=template&id=75de7ece&scoped=true&"
import script from "./LivingOptionSubsections.vue?vue&type=script&lang=js&"
export * from "./LivingOptionSubsections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75de7ece",
  null
  
)

export default component.exports